import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Station from './pages/Station';
import About from './pages/About';
import Blog from './pages/Blog'; 
import Calculators from './pages/Calculators';
import QsoMap from './pages/QsoMap';
import Login from './pages/Login';
import AdminLayout from './pages/admin/AdminLayout';
import AdminPosts from './pages/admin/AdminPosts';
import AdminPostForm from './pages/admin/AdminPostForm';
import AdminStats from './pages/admin/AdminStats';
import PageTracker from './components/PageTracker';
import './App.css';

function App() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('meta.defaultTitle')}</title>
        <meta name="description" content={t('meta.description')} />
        <meta name="keywords" content={t('meta.keywords')} />
      </Helmet>
      <Router>
        <div className="App">
          <Navbar />
          <PageTracker />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimda" element={<About />} />
              <Route path="/ekipmanlar" element={<Station />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/map" element={<QsoMap />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="posts" replace />} />
                <Route path="posts" element={<AdminPosts />} />
                <Route path="posts/new" element={<AdminPostForm />} />
                <Route path="posts/edit/:id" element={<AdminPostForm />} />
                <Route path="stats" element={<AdminStats />} />
              </Route>
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
